class Duration {
    constructor(jsonStructure) {
        this.number_of_bars = jsonStructure.number_of_bars;
        this.time_length = jsonStructure.time_length;
    }
}

export class GeneralInformation {
    constructor(jsonStructure) {
        this.assigned_annotators = jsonStructure.assigned_annotators
        this.original_filename = jsonStructure.original_filename
        this.displayed_filename = jsonStructure.displayed_filename
        this.file_path = jsonStructure.file_path
        this.song_title = jsonStructure.song_title
        this.artist = jsonStructure.artist
        this.lyricist = jsonStructure.lyricist
        this.songwriter = jsonStructure.songwriter
        this.arranger = jsonStructure.arranger
        this.composer = jsonStructure.composer
        this.year_of_publication = jsonStructure.year_of_publication
        this.presence_of_main_melody = jsonStructure.presence_of_main_melody
        this.music_type = jsonStructure.music_type
        this.duration = new Duration(jsonStructure.duration)
        this.music_completeness = jsonStructure.music_completeness
        this.music_compositional_craftsmanship = jsonStructure.music_compositional_craftsmanship
        this.emotion = jsonStructure.emotion
        this.imagery = jsonStructure.imagery
        this.regional_classification = jsonStructure.regional_classification
        this.music_style = jsonStructure.music_style
        this.music_style_description = jsonStructure.music_style_description
        this.professional_description = jsonStructure.professional_description
        this.casual_description = jsonStructure.casual_description
        this.completed = jsonStructure.completed ?? false
    }
    
}
